import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { MessageCircle, Clock, FileText } from "lucide-react";
import { Message } from "../../types/generated";
import { useTranslation } from "react-i18next";

interface MessageStatsProps {
  messages: Message[];
}

export const MessageStats = ({ messages }: MessageStatsProps) => {
  const { t } = useTranslation();
  const now = new Date();
  const weekAgo = new Date();
  weekAgo.setDate(weekAgo.getDate() - 7);

  const sentThisWeek =
    messages?.filter(
      (m) => m.status === "sent" && m.sent_at && new Date(m.sent_at) >= weekAgo
    ).length || 0;

  const scheduledMessages =
    messages?.filter((m) => m.status === "scheduled").length || 0;
  const draftMessages =
    messages?.filter((m) => m.status === "pending").length || 0;

  const stats = [
    {
      title: t("stats.sent_this_week"),
      value: sentThisWeek,
      subValue: t("stats.sent_this_week_description"),
      icon: MessageCircle,
      color: "text-blue-500",
      bgColor: "bg-blue-50",
    },
    {
      title: t("stats.scheduled_messages"),
      value: scheduledMessages,
      subValue: t("stats.scheduled_messages_description"),
      icon: Clock,
      color: "text-green-500",
      bgColor: "bg-green-50",
    },
    {
      title: t("stats.drafts"),
      value: draftMessages,
      subValue: t("stats.drafts_description"),
      icon: FileText,
      color: "text-yellow-500",
      bgColor: "bg-yellow-50",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {stats.map((stat, index) => (
        <Card
          key={index}
          className="hover:shadow-lg transition-shadow duration-200"
        >
          <CardHeader
            className={`flex flex-row items-center justify-between space-y-0 pb-2 ${stat.bgColor} rounded-t-lg`}
          >
            <CardTitle className="text-sm font-medium">{stat.title}</CardTitle>
            <div className={`p-2 rounded-full ${stat.bgColor}`}>
              <stat.icon className={`h-4 w-4 ${stat.color}`} />
            </div>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="text-2xl font-bold">{stat.value}</div>
            <p className="text-xs text-muted-foreground mt-1">
              {stat.subValue}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
